import Vue from "vue";
import Vuex from "vuex";
import CartDTO from "./../shared/model/Cart";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        objStore: {
            nomeLoja: null,
            enderecoDTO: {
                pais: null,
                estado: null,
                cidade: null,
                bairro: null,
                endereco: null,
                complemento: null,
                numero: null,
                cep: null
            },
            horarioFuncionamento: null,
            valorEntrega: null,
            tempoEntrega: null,
            descricaoLoja: null,
            urlLogo: null,
            urlImagemCover: null,
            situacaoAbertura: null,
            listaProdutos: null
        },
        pedido: new CartDTO(),
        dadosPessoais: {
            cliente: {
                nome: null,
                cpf: null,
                email: null,
                celular: null,
                dataNascimento: null,
                endereco: {
                    pais: "BR",
                    estado: null,
                    cidade: null,
                    bairro: null,
                    endereco: null,
                    numero: null,
                    complemento: null,
                    cep: null
                }
            },
            enderecoIguais: true,
            enderecoEntrega: {
                pais: "BR",
                estado: null,
                cidade: null,
                bairro: null,
                endereco: null,
                numero: null,
                complemento: null,
                cep: null
            }
        },
        objCategoria: null,
        categoriaSelecionada: "",
        pesquisarProduto: "",
        user: null,
        toogleMicroApp: true,
        toogleFooter: false,
        simulacaoPlano: null,
        dadosCadastroConta: null,
        reagendartemp: null
    },
    mutations: {
        objStoreStorage(state, objStore) {
            state.objStore = objStore;
        },
        dadosCadastroContaStorage(state, dadosCadastroConta) {
            state.dadosCadastroConta = dadosCadastroConta;
        },
        simulacaoPlanoStorage(state, simulacaoPlano) {
            state.simulacaoPlano = simulacaoPlano;
        },
        objCartStorage(state, objCart) {
            state.objStore = objCart;
        },
        pedidoAdicionarProduto(state, objProduto) {
            if (state.pedido.itens == null || state.pedido.itens == "") {
                state.pedido.itens = [];
            }
            const indexItens = state.pedido.itens.findIndex(
                item => item.produto.id === objProduto.produto.id
            );
            if (indexItens > -1) {
                state.pedido.itens[indexItens].quantidade += objProduto.quantidade;
            } else {
                state.pedido.itens.push(objProduto);
            }

            if(objProduto.item) {
                state.pedido.itens[indexItens].id += objProduto.item.id;
            }

            let valorAdicional = 0;

            if (objProduto.produto.categoriaModificadorList.length > 0) {
                objProduto.produto.categoriaModificadorList.forEach(el => {
                    el.produtoModificadorList.forEach(pr => {
                        valorAdicional += pr.valorUnitario + pr.valorFreteAdicional;;
                    });
                });
            }

            if (objProduto.produto) {
                state.pedido.valorCompra +=
                    (objProduto.produto.valorUnitario + valorAdicional) * objProduto.quantidade;
                state.pedido.valorFrete +=
                    objProduto.produto.valorFrete * objProduto.quantidade;
            }

            state.pedido.valorTotal =
                state.pedido.valorCompra + state.pedido.valorFrete;
            localStorage.setItem("carrinho", JSON.stringify(state.pedido));
        },
        pedidoRemoverProduto(state, objProduto) {
            if (state.pedido.itens == null || state.pedido.itens == "") {
                state.pedido.itens = [];
            }
            const indexItens = state.pedido.itens.findIndex(
                item => item.produto.id === objProduto.produto.id
            );
            if (indexItens > -1)
                state.pedido.itens[indexItens].quantidade -= objProduto.quantidade;

            let valorAdicional = 0;

            if (objProduto.produto.categoriaModificadorList.length > 0) {
                objProduto.produto.categoriaModificadorList.forEach(el => {
                    el.produtoModificadorList.forEach(pr => {
                        valorAdicional += pr.valorUnitario + pr.valorFreteAdicional;;
                    });
                });
            }

            if (objProduto.produto) {
                state.pedido.valorCompra -=
                    (objProduto.produto.valorUnitario + valorAdicional) * objProduto.quantidade;
                state.pedido.valorFrete -=
                    objProduto.produto.valorFrete * objProduto.quantidade;
            }
            state.pedido.valorTotal =
                state.pedido.valorCompra + state.pedido.valorFrete;
            localStorage.setItem("carrinho", JSON.stringify(state.pedido));
        },
        pedidoApagarProduto(state, idProduto) {
            if (state.pedido.itens == null || state.pedido.itens == "") {
                state.pedido.itens = [];
            }
            const indexItens = state.pedido.itens.findIndex(
                item => item.produto.id === idProduto
            );
            let valorAdicional = 0;

            if (state.pedido.itens[indexItens].produto.categoriaModificadorList.length > 0) {
                state.pedido.itens[indexItens].produto.categoriaModificadorList.forEach(el => {
                    el.produtoModificadorList.forEach(pr => {
                        valorAdicional += pr.valorUnitario + pr.valorFreteAdicional;;
                    });
                });
            }

            state.pedido.valorCompra -=
                (state.pedido.itens[indexItens].produto.valorUnitario + valorAdicional) *
                state.pedido.itens[indexItens].quantidade;
            state.pedido.valorFrete -=
                state.pedido.itens[indexItens].produto.valorFrete *
                state.pedido.itens[indexItens].quantidade;
            state.pedido.itens[indexItens] = "";
            state.pedido.itens = state.pedido.itens.filter(Boolean);
            state.pedido.valorTotal =
                state.pedido.valorCompra === 0 ?
                    0 :
                    state.pedido.valorCompra + state.pedido.valorFrete;
            localStorage.setItem("carrinho", JSON.stringify(state.pedido));
        },
        pedidoLocalStorage(state, objPedido) {
            state.pedido = objPedido;
        },
        lojaLocalStorage(state, redeLoja) {
            state.redeLoja = redeLoja;
            state.pedido.valorEntrega = redeLoja.valorEntrega;
        },
        pedidoDadosPessoais(state, dadosPessoais) {
            state.dadosPessoais = dadosPessoais;
        },
        limparPedido(state) {
            state.pedido = new CartDTO();
        },
        objCategoria(state, objCategoria) {
            state.objCategoria = objCategoria;
        },
        selecionaCategoria(state, categoria) {
            state.pesquisarProduto = '';
            state.categoriaSelecionada = categoria;
        },
        selecionaCategoriaId(state, categoriaId) {
            state.categoriaSelecionadaId = categoriaId;
        },
        pesquisarProduto(state, produto) {
            state.pesquisarProduto = produto.trim();
        },
        loginApp(state, user) {
            !user && sessionStorage.clear();
            state.user = user;
        },
        toogleMicroApp(state, bool) {
            const isNumber = Number.isInteger(bool);
            const temp = localStorage.getItem("toogleMicroApp");
            const toogle = isNumber ? bool : temp == null ? 1 : +temp;
            localStorage.setItem("toogleMicroApp", toogle);
            state.toogleMicroApp = toogle;

            if (toogle === 0) {
                localStorage.setItem("accept-cookies", new Date());
            }
        },
        toogleFooter(state, bool) {
            const isNumber = Number.isInteger(bool);
            const temp = localStorage.getItem("toogleFooter");
            const toogle = isNumber ? bool : temp == null ? 1 : +temp;
            localStorage.setItem("toogleFooter", toogle);
            state.toogleFooter = toogle;
        },
        setReagendartemp(state, payload) {
            state.reagendartemp = payload;
        },
        resetReagendartemp(state) {
            state.reagendartemp = null;
        }

    },
    actions: {
        simulacaoPlanoStorage(context, simulacaoPlano) {
            context.commit("simulacaoPlanoStorage", simulacaoPlano);
        },
        dadosCadastroContaStorage(context, dadosCadastroConta) {
            context.commit("dadosCadastroContaStorage", dadosCadastroConta);
        },

        objStoreStorage(context, objStore) {
            context.commit("objStoreStorage", objStore);
        },
        objCartStorage(context, objCart) {
            context.commit("objStoreStorage", objCart);
        },
        pedidoAdicionarProduto(context, produto) {
            context.commit("pedidoAdicionarProduto", produto);
        },
        pedidoRemoverProduto(context, produto) {
            context.commit("pedidoRemoverProduto", produto);
        },
        pedidoApagarProduto(context, idProduto) {
            context.commit("pedidoApagarProduto", idProduto);
        },
        pedidoLocalStorage(context, objPedido) {
            context.commit("pedidoLocalStorage", objPedido);
        },
        pedidoDadosPessoais(context, dadosPessoais) {
            context.commit("pedidoDadosPessoais", dadosPessoais);
        },
        limparPedido(context) {
            context.commit("limparPedido", new CartDTO());
        },
        objCategoria(context, objCategoria) {
            context.commit("objCategoria", objCategoria);
        },
        selecionaCategoria(context, categoria) {
            context.commit("selecionaCategoria", categoria);
        },
        selecionaCategoriaId(context, categoria) {
            context.commit("selecionaCategoriaId", categoria);
        },
        pesquisarProduto(context, produto) {
            context.commit("pesquisarProduto", produto);
        },
        loginApp(context, user) {
            context.commit("loginApp", user);
        },
        toogleMicroApp(context, bool) {
            context.commit("toogleMicroApp", bool);
        },
        toogleFooter(context, bool) {
            context.commit("toogleFooter", bool);
        },
        setReagendartemp({ commit }, payload) {
            commit('setReagendartemp', payload);
        },
        resetReagendartemp({ commit }) {
            commit('resetReagendartemp');
        }
    },
    modules: {},
    getters:{
        getReagendartemp: state => state.reagendartemp
    }
});
